import React, { useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useStoreon } from 'storeon/react';

import DealerContactInformationMiwindows from "../../DealerContactInformationMiwindows";
import InformationAboutYourClient from '../../InformationAboutYourClient';
import WhoToContact from "../../WhoToContact";

import Btn from "../../Btn";
import Info from "../../Info";
import axios from "axios";
import BlockDescribeProblemServiceRequestDealerMiwindows from "../../BlockDescribeProblemServiceRequestDealerMiwindows";
import Information from "../../Information";
import Loader from '../../Loader';

const ServiceRequestDealerMiwindowsForm = ( { id, site = '' } ) => {
    const brand = site === 'sunrise' ? 'Sunrise' : site === 'pgt' ? 'PGT' : 'MI Windows and Doors';
    const [serverResponse, setServerResponse] = useState( '' );
    const [submitForm , setSubmitForm] = useState(false);

    const methods = useForm( {
        mode: 'all',
        reValidateMode: 'onChange',
        // Default values for field array.
        defaultValues: {
            your_project: [{}],
            sms_opt_in: false,
        },
    } );
    const { errors, trigger, handleSubmit, watch, formState } = methods;

    const selectedContact = watch('contact_method');
    const selectedSubject = watch('contact_subject');
    const mobilePhone = watch('mobile_phone');

    const isSubmitEnabled = () => {
        if (((selectedSubject === 'Customer' || selectedSubject === 'Both') && selectedContact === 'Text')) {
            return formState.isValid && mobilePhone && /^[0-9]{10}$/.test(mobilePhone);
        }

         if ((mobilePhone && !/^[0-9]{10}$/.test(mobilePhone))) {
            return formState.isValid && mobilePhone && /^[0-9]{10}$/.test(mobilePhone);
        }

        return formState.isValid;
    };

    const onSubmit = ( data ) => {
        const endpointUrl = `${window.location.origin}/sr/api`;
        setSubmitForm(true);

        axios( {
            method: 'post',
            url: endpointUrl,
            data: data,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        } )
            .then( ( response ) => {
                if ( response.status === 200 ) {
                    window.location.href = `${window.location.origin}${window.location.pathname.replace( /\/+$/, '' )}/submission`;
                }
            } )
            .catch( ( error ) => {
                setServerResponse( error.response.data );
                setSubmitForm(false);
                console.log( error );
            } );
    }
    const { dispatch, groups } = useStoreon( 'groups' );
    /**
     * Trigger form validation on component init.
     * This action will pre-populate errors object.
     */
    useEffect( () => {
        trigger();
    }, [trigger] );

    /**
     * Check form errors and determine if fieldset should be disabled.
     */
    useEffect(() => {
        for (let i = 1; i < groups.length; i += 1) {
            const { fields: groupFields } = groups[i - 1];
            const isValid = !Object.keys(errors).some((item) => groupFields.includes(item));

            // Always enable the third section when Text is selected
            if (i === 2 && ((selectedSubject === 'Customer' || selectedSubject === 'Both') && selectedContact === 'Text')) {
                if (groups[i].disabled) {
                    dispatch('CHANGE_FIELDSET_STATE', { id: i, disabled: false });
                }
                continue;
            }

            if (i === 2 && (mobilePhone && !/^[0-9]{10}$/.test(mobilePhone))) {
                if (groups[i].disabled) {
                    dispatch('CHANGE_FIELDSET_STATE', { id: i, disabled: false });
                }
                continue;
            }

            if (groups[i].disabled === isValid) {
                dispatch('CHANGE_FIELDSET_STATE', { id: i, disabled: !isValid });
            }
        }
    });

    return (
        <div className={`service-request-form container`}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit( onSubmit )}>
                    <h1 className={'title-big'}>Service Request</h1>
                    <Info styleText={'text-grey'}>
                        Need to schedule service for {brand} windows or patio doors? Fill out the form below and our
                        service team will contact you soon.
                    </Info>
                    <DealerContactInformationMiwindows index={0} site={site}/>
                    <InformationAboutYourClient index={1} showCheckbox optionText brand={brand}/>
                    <WhoToContact index={2}/>
                    <BlockDescribeProblemServiceRequestDealerMiwindows disabled={groups[2].disabled} index={3} idForm={id} brand={brand}/>
                    <Information index={4}/>
                    <Btn disabled={!isSubmitEnabled() || submitForm}>
                        <input
                            type="submit"
                            disabled={!isSubmitEnabled() || submitForm}
                            value={'Request Service'}
                        />
                    </Btn>
                    {serverResponse && <div className="server-error">{serverResponse}</div>}
                </form>
            </FormProvider>
            {submitForm && <Loader />}
        </div>
    );
};

export default ServiceRequestDealerMiwindowsForm;
